(ns frontend.ui.component.dropdown-button.style
  (:require
   [frontend.ui.style.theme.core :as theme]
   [frontend.ui.style.theme.core :refer [color]]
   [garden.util :refer [space-join]]
   [herb.core :refer [defglobal]]))

(defglobal
 dropdown
 [:.dropdown-menu
  {:border (space-join ["1px" "solid" (theme/color [:rich-text-editor :toolbar :border-bottom])])}])

(defn item-list
  []
  {:display        "flex"
   :flex-direction "column"})

(defn item
  []
  (with-meta
    {:background-color (theme/color [:dropdown :bg])
     :color (theme/color [:dropdown :color])}
    {:pseudo
     {:hover
      {:color (space-join [(theme/color [:dropdown :hover :color]) "!important"])
       :background-color (space-join [(theme/color [:dropdown :hover :bg]) "!important"])}
      :focus
      {:color (space-join [(theme/color [:dropdown :focus :color]) "!important"])
       :background-color (space-join [(theme/color [:dropdown :focus :bg]) "!important"])}}}))
